var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.50661 16.28938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cavet-cls-1,.cavet-cls-3{fill:none;}.cavet-cls-2{clip-path:url(#clip-path);}.cavet-cls-3{stroke:#618ac7;stroke-miterlimit:10;stroke-width:5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.00003 -0.00013)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cavet-cls-1",
    width: 25.507,
    height: 16.289
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cavet-cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cavet-cls-3",
    points: "1.768 1.768 12.754 12.754 23.739 1.768"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCaret);
export default __webpack_public_path__ + "static/media/blue-caret.7ebc78a5255e9f56b476fd14c81a0e50.svg";
export { ForwardRef as ReactComponent };